import React from 'react';
import { Grid, Chip, Box, Typography } from '@mui/material';
import { useIsMobileView } from '../../../utils/responsive';
import { getThemeByAccountId } from '../../../utils/styleConstants';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/types/rootState';

interface GeneratedTicketsProps {
  generatedTickets: Array<number>;
  limit: number;
}

export const GeneratedTickets = ({ generatedTickets, limit }: GeneratedTicketsProps) => {
  const isMobile = useIsMobileView();
  const accountId = useSelector(({ account }: RootState) => account.id);
  const themeType = getThemeByAccountId(accountId);
  const chipTextColor = themeType === 'dark' ? '#000' : '#FFF';

  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        px: 3,
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography
        variant="h6"
        sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}
      >
        Números Generados
      </Typography>

      <Grid
        container
        spacing={2}
        justifyContent="center"
        sx={{
          maxHeight: isMobile ? '65vh' : '40vh',
          overflowY: 'auto',
          background: "transparent"
        }}
      >
        {generatedTickets.length > 0 ? (
          generatedTickets.map((ticketNumber) => (
            <Grid item key={ticketNumber}>
              <Chip
                label={
                  <Typography
                    sx={{
                      fontWeight: 'bold',
                      color: chipTextColor,
                      fontSize: '1rem',
                    }}
                  >
                    {ticketNumber.toString().padStart(limit.toString().length - 1, '0')}
                  </Typography>
                }
                color="primary"
                sx={{
                  height: 60,
                  width: 60,
                  borderRadius: '50%',
                  boxShadow: 3,
                  transition: 'all 0.2s ease-in-out',
                  '&:hover': {
                    transform: 'scale(1.1)',
                    boxShadow: 6,
                  },
                  '& .MuiChip-label': {
                    padding: 0,
                  },
                }}
              />
            </Grid>
          ))
        ) : (
          <Grid item>
            <Typography variant="body2" color="textSecondary">
              No se encontraron números
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
